export default __webpack_public_path__ + "static/media/52-min.abe28ce8.jpg";